core.constant('remindPasswordMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "APPLICATION": {
          "REMIND_PASSWORD": "Przypomnij hasło"
        },
        "TABBAR": {
        },
        "BREADCRUMB": {
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "REMIND_PASSWORD": {
          "FILL_DATA_TO_REMIND_PASSWORD" : "Wygeneruj nowe hasło.",
          "MAIL_IS_SENT" : "Link do zmiany hasła został wysłany na adres e-mail powiązany z kontem",
          "GO_TO_LOGIN" : "Wróc do strony logowania",
          "SEND" : "Wyślij"
        }
      }
    }
  }
});
